import { config } from "/app.config"

export const GOOGLE_TAG_MANAGER_ID = process.env.VUE_APP_GOOGLE_TAG_MANAGER_ID

export const isGtmEnabled = () => {
  return GOOGLE_TAG_MANAGER_ID && GOOGLE_TAG_MANAGER_ID.length && config.isZeno
}

export const trackGtmEvent = (eventData) => {
    try {
        if (isGtmEnabled() && window.dataLayer) {
            window.dataLayer.push(eventData);
        }
    } catch (e) {
        console.log("[GTM] Error: ", e);
    }
}